(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stage-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mfn-faq')) {
    class MfnFaq extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-mfq-keys]'));
        this.empty = this.querySelector('[data-mfq-empty]');
        this.labels = Array.from(this.querySelectorAll('[data-mfq-stage]'));
        this.wrapper = this.closest('.mfq');
        this.openFirst = this.dataset.openFirst === 'true';
        this.hideEmpty = this.dataset.hideEmpty === 'true';

        this.onStage = this.onStage.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        document.addEventListener('mfn:stage-change', this.onStage);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        // The timeline may have announced its stage before this section loaded.
        if (window.mfnStage) this.filter(window.mfnStage.key, window.mfnStage.name, false);
      }

      disconnectedCallback() {
        document.removeEventListener('mfn:stage-change', this.onStage);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onStage(event) {
        if (!event.detail) return;
        this.filter(event.detail.key, event.detail.name, true);
      }

      // Theme editor: show the selected question even if it belongs to another stage.
      onBlockSelect(event) {
        var item = event.target.closest('[data-mfq-keys]');
        if (!item) return;
        item.hidden = false;
        item.open = true;
        if (this.wrapper) this.wrapper.hidden = false;
      }

      filter(key, name, animate) {
        var needle = ',' + key + ',';
        var count = 0;
        var openFirst = this.openFirst;

        this.items.forEach(function (item) {
          var keys = item.getAttribute('data-mfq-keys') || '';
          var show = keys.indexOf(',all,') > -1 || keys.indexOf(needle) > -1;
          item.hidden = !show;
          if (show) {
            count += 1;
            item.open = openFirst && count === 1;
          } else {
            item.open = false;
          }
        });

        if (name) {
          this.labels.forEach(function (label) { label.textContent = name; });
        }

        if (this.empty) this.empty.hidden = count > 0 || !this.empty.textContent.trim();
        if (this.wrapper) this.wrapper.hidden = count === 0 && this.hideEmpty;

        if (animate) this.classList.add('is-switched');
      }
    }
    customElements.define('mfn-faq', MfnFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stage-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mfn-timeline')) {
    class MfnTimeline extends HTMLElement {
      connectedCallback() {
        this.stages = Array.from(this.querySelectorAll('[data-mfn-stage]'));
        if (!this.stages.length) return;

        this.collapsible = this.dataset.collapsible === 'true';
        this.fallback = Math.max(0, (parseInt(this.dataset.default, 10) || 1) - 1);
        this.current = this.stages.findIndex(function (stage) { return stage.classList.contains('is-active'); });
        this.mobile = window.matchMedia('(max-width: 989.98px)');

        this.onClick = this.onClick.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);

        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        if (this.mobile.addEventListener) {
          this.mobile.addEventListener('change', this.onLayoutChange);
        } else if (this.mobile.addListener) {
          this.mobile.addListener(this.onLayoutChange);
        }

        // Tell the Stage FAQ section which stage is open on page load
        if (this.current >= 0) this.announce(this.stages[this.current]);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (!this.mobile) return;
        if (this.mobile.removeEventListener) {
          this.mobile.removeEventListener('change', this.onLayoutChange);
        } else if (this.mobile.removeListener) {
          this.mobile.removeListener(this.onLayoutChange);
        }
      }

      onClick(event) {
        var target = event.target.closest('[data-mfn-select]');
        if (!target) return;
        var index = this.stages.findIndex(function (stage) { return stage.contains(target); });
        if (index < 0) return;
        this.classList.add('is-interacted');
        if (index === this.current && this.collapsible && this.mobile.matches) {
          this.show(-1);
        } else {
          this.show(index);
        }
      }

      onBlockSelect(event) {
        var index = this.stages.findIndex(function (stage) { return stage.contains(event.target); });
        if (index >= 0) this.show(index);
      }

      onLayoutChange() {
        if (!this.mobile.matches && this.current === -1) this.show(this.fallback);
      }

      show(index) {
        this.stages.forEach(function (stage, i) {
          var open = i === index;
          var trigger = stage.querySelector('.mfn__trigger');
          var panel = stage.querySelector('.mfn__panel');
          stage.classList.toggle('is-active', open);
          if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (panel) panel.hidden = !open;
        });
        this.current = index;
        // Tell the Stage FAQ section which stage was selected
        if (index >= 0) this.announce(this.stages[index]);
      }

      announce(stage) {
        var detail = { key: stage.dataset.mfnKey, name: stage.dataset.mfnName };
        window.mfnStage = detail;
        document.dispatchEvent(new CustomEvent('mfn:stage-change', { detail: detail }));
      }
    }
    customElements.define('mfn-timeline', MfnTimeline);
  }

  } catch(e) { console.error(e); }
})();
})();
